app.controller('patientVisitListController', ['$scope', '$stateParams', '$state', '$mdDialog', '$mdToast', '$translate', 'objectHelper', 'baseModel', 'applicationModel', 'visitModel', 'visitCardModel', 'userModel', 'config',
    function ($scope, $stateParams, $state, $mdDialog, $mdToast, $translate, objectHelper, baseModel, applicationModel, visitModel, visitCardModel, userModel, config) {

        function setData() {
            $scope.criteria = new VisitDataGridCriteria();
            $scope.criteria.rowsPerSheet = 20;
            $scope.criteria.patientId = $stateParams.patientId;
            $scope.criteria.sortColumns = [new EsDataGridSort('date', true)];

            $scope.visits = [];

            $scope.columns = [
                {
                    field: "date | date:'dd.MM.yyyy HH:mm'",
                    displayName: $translate.instant('T.DATA.DATE')
                },
                {
                    field: "visitStatus | prefix:'T.ENUM.VISIT_STATUS.' | translate",
                    displayName: "T.DATA.STATUS"
                },
                {
                    field: "office.name",
                    displayName: "T.MODULE.PATIENT.OFFICE"
                }
            ];

            if(userModel.userHasRight(Constant.RIGHT.VISIT_CARD_MODULE_ACCESS)) {
                $scope.columns.push({
                    field: "mainDiagnosis.icd10.value",
                    displayName: "T.MODULE.VISIT.RECOGNITION"
                });
                $scope.columns.push({
                    cellTemplate: 'edm/application/view/app/patient/grid-template/meedy-data-visit-epicrisis.html',
                    displayName: "T.MODULE.VISIT.EPICRISIS"
                });

            }

            if(!config.MEEDY) {
                $scope.buttons = [
                    /*{
                        icon: 'content:add',
                        buttonClass: ['md-fab', 'md-primary', 'patient-list-add-button', 'md-mini'],
                        action: 'addVisit'
                    }*/
                ];
            }

            $scope.setStretchView();
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on('$destroy', function () {
            });

            $scope.$on(Event.VISIT.GET_DATA_PAGE.SUCCESS, function(event, dataPage, pageNumber) {
                $scope.visits = dataPage.data;
                $scope.numberOfPages = dataPage.numberOfPages;
            });

            $scope.$on(Event.VISIT.DELETE.SUCCESS, function() {
                visitModel.getDataPage($scope.criteria);
            });

            $scope.$on(Event.VISIT.CANCEL.SUCCESS, function() {
                visitModel.getDataPage($scope.criteria);
            });

        }

        function setActions() {
            $scope.onCriteriaChange = function(criteria){
                visitModel.getDataPage(criteria);
            };

            $scope.addVisit = function() {
                $state.go(Constant.STATE.APP.PATIENT.VIEW.VISIT_CREATE, {patientId: $stateParams.patientId});
            };

            $scope.updateVisit = function(visit) {
                if(visit.visitStatus === Enum.VISIT_STATUS.PLANNED) {
                    $state.go(Constant.STATE.APP.VISIT.EDIT, {visitId: visit.id});
                }
            };

            $scope.deleteVisit = function(visit) {
                var confirm = $mdDialog.confirm({
                    title: $translate.instant('T.MODULE.VISIT.VISIT_DELETE_CONFIRMATION'),
                    ok: $translate.instant('T.UI.APPLICATION.YES'),
                    cancel: $translate.instant('T.UI.APPLICATION.NO')
                });
                $mdDialog.show(confirm).then(function() {
                    visitModel.delete(visit);
                }, function() {
                    return false;
                });
            };

            $scope.downloadPDF = function(idVisitCard) {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/popup/popup-visitCardPdf.html',
                    controller: 'popupVisitCardPDFController',
                    resolve: {
                        idVisitCard: function () {
                            return idVisitCard;
                        }
                    }
                });
            };

            $scope.criteriaChanged = function () {
                visitModel.getDataPage($scope.criteria);
            };

            $scope.viewVisitCard = function (visit) {
                if(visit.visitStatus === Enum.VISIT_STATUS.IN_PROGRESS || visit.visitStatus === Enum.VISIT_STATUS.PLANNED) {
                    $state.go(Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD, {patientId: $stateParams.patientId, visitId: visit.id});
                } else {
                    $mdToast.show(
                        $mdToast.simple({
                            content: $translate.instant('T.MODULE.VISIT.CANNOT_OPEN_VISIT_CARD_FOR_THIS_VISIT'),
                            hideDelay: 1500,
                            position: 'top right'
                        })
                    );
                }
            };

            $scope.showVisitDetails = function (visit) {
                if(userModel.userHasRight(Constant.RIGHT.VISIT_READ)) {
                    if(!visit.firstForPatientDoctor || visit.visitStatus != Enum.VISIT_STATUS.PLANNED) {
                        $mdDialog.show({
                            templateUrl: 'edm/application/view/app/patient/popup/popup-visit-details.html',
                            controller: 'popupVisitDetailsController',
                            resolve: {
                                visit: function () {
                                    return visit;
                                }
                            },
                            skipHide: true // this is a hack for not closing modals problem
                        });
                    }
                    if(visit.firstForPatientDoctor && visit.visitStatus === Enum.VISIT_STATUS.PLANNED && visit.doctor.id != userModel.currentUser.id) {
                        $mdDialog.show({
                            templateUrl: 'edm/application/view/app/patient/popup/popup-visit-details.html',
                            controller: 'popupVisitDetailsController',
                            resolve: {
                                visit: function () {
                                    return visit;
                                }
                            },
                            skipHide: true // this is a hack for not closing modals problem
                        });
                    }
                    if(visit.firstForPatientDoctor && visit.visitStatus === Enum.VISIT_STATUS.PLANNED && visit.doctor.id === userModel.currentUser.id) {
                        $mdDialog.show({
                            templateUrl: 'edm/application/view/app/patient/popup/popup-patient-first-visit.html',
                            controller: 'popupVisitDetailsController',
                            resolve: {
                                visit: function () {
                                    return visit;
                                }
                            },
                            skipHide: true // this is a hack for not closing modals problem
                        });
                    }
                }

            };

            $scope.downloadEpicrisisForPatientVisit = function (visit) {
                visitCardModel.downloadPDF(visit.visitCard.id);
            };

        }

        function configureInterface() {

        }

        function initialize() {
            applicationModel.fillViewportMode = true;
            visitModel.getDataPage($scope.criteria);
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
